module.exports = __webpack_public_path__ + "img/points.809e5a83.svg";